<template>
    <div class='sp-row'>
        <slot></slot>
    </div>
</template>

<script>
export default {
}
</script>

<style scoped>
    .sp-row {
        background-color: green;
        display: flex;
        margin: 0 -10px 0 -10px;
        -webkit-flex-wrap: wrap;
        flex-wrap: wrap;
    }
</style>


// WEBPACK FOOTER //
// SPRow.vue?67e6f9fd